// components/Modal/BankApprovalPendingModal.jsx
import React from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Row,
  Col,
  Progress,
} from "reactstrap";
import { FaClock, FaShieldAlt, FaUserCheck, FaEnvelope } from "react-icons/fa";

const BankApprovalPendingModal = ({ isOpen }) => {
  return (
    <Modal
      isOpen={isOpen}
      backdrop="static"
      keyboard={false}
      className="modal-dialog-centered"
      size="lg"
      style={{ zIndex: 9999 }}
    >
      <ModalHeader>
        
            Bank Details Approval Pending
         
      </ModalHeader>

      <ModalBody>
        <Row>
          <Col md={12}>
            {/* Status Icon */}
            <div className="text-center mb-4">
              <div 
                className="d-inline-flex align-items-center justify-content-center"
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  backgroundColor: "#fff3cd",
                  border: "3px solid #ffc107"
                }}
              >
                <FaClock style={{ fontSize: "50px", color: "#ff9800" }} />
              </div>
            </div>

            {/* Title */}
            <h4 className="text-center mb-2" style={{ color: "#2c3e50" }}>
              Bank Details Verification In Progress
            </h4>
            
            <p className="text-center text-muted mb-4" style={{ fontSize: "16px" }}>
              Your bank details have been submitted for verification. 
              You'll get access to the dashboard once approved.
            </p>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default BankApprovalPendingModal;